import { defineComponent } from "vue";

export const RenderOnlySlot = defineComponent({
  name: "RenderOnlySlot",
  setup: function (props, { slots }) {
    return () => slots.default?.();
  },
});
